import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Text } from '@leroy-merlin-br/backyard-react-ui'

const baseStyles = ({ theme }) => css`
  label: price-tag;

  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;

  background-color: ${theme.colors.white};
  border-top: 4px solid ${theme.colors.p500};
  padding: ${theme.spacings.kilo} 0 ${theme.spacings.bit};
  margin: 0 10px;

  ${theme.media.mega} {
    margin: 0;
  }
`

const promotionalStyles = ({ theme, isPromotional }) =>
  isPromotional &&
  css`
    label: price-tag--promotional;

    border-color: ${theme.colors.r500};

    & ${ToPriceContainer} {
      label: price-tag__to-price--promotional;

      color: ${theme.colors.r500};
    }
  `

const blackweekendStyles = ({ theme, isBlackWeekend }) =>
  isBlackWeekend &&
  css`
    label: price-tag--black-weekend;

    background-color: ${theme.colors.black};
    color: ${theme.colors.p500};
    padding-left: ${theme.spacings.byte};
    border-color: ${theme.colors.p500};

    & ${ToPriceContainer} {
      label: price-tag__to-price--black-weekend;

      color: ${theme.colors.p500};
    }

    & ${ShopName} {
      label: price-tag__shop-name--black-weekend;

      color: ${theme.colors.white};
    }

    & ${Discount} {
      label: price-tag__discount--black-weekend;

      background-color: ${theme.colors.p500};
      color: ${theme.colors.white};
    }
  `

const unavailableStyles = ({ theme, isUnavailable }) =>
  isUnavailable &&
  css`
    label: price-tag--sold-out;

    border-color: ${theme.colors.n600};
  `

export const PriceTag = styled.div(
  baseStyles,
  promotionalStyles,
  blackweekendStyles,
  unavailableStyles
)

const mainWrapperStyles = () => css`
  label: price-tag__main;

  flex: 1;
`

export const MainWrapper = styled('div')(mainWrapperStyles)

const toPriceContainerStyles = ({ theme }) => css`
  label: price-tag__to-price;

  width: 100%;

  font-size: ${theme.typography.headings.tera.fontSize};
  font-weight: ${theme.font.weight.bold};
`

export const ToPriceContainer = styled.div(toPriceContainerStyles)

const toPriceIntegerStyles = () => css`
  label: to-price__integer;

  font-size: 30px;
`

export const ToPriceInteger = styled('span')(toPriceIntegerStyles)

const priceUnitStyles = ({ theme }) => css`
  label: to-price__unit;

  font-size: ${theme.typography.text.mega.fontSize};
`

export const PriceUnit = styled('span')(priceUnitStyles)

const containerStyles = () => css`
  label: price-tag__container;

  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  width: 100%;
`

export const Container = styled('div')(containerStyles)

const badgeStyles = () => css`
  label: price-tag__badge;

  align-self: flex-end;

  width: 87px;
`

export const Badge = styled('div')(badgeStyles)

const shopNameStyles = ({ theme }) => css`
  label: price-tag__shop-name;

  color: ${theme.colors.n400};

  display: block;

  margin: ${theme.spacings.bit};
  margin-left: 0;

  span {
    color: ${theme.colors.n700};
  }
`

export const ShopName = styled(Text)(shopNameStyles)

const discountStyle = ({ theme }) =>
  css`
    label: price-tag__discount;

    background-color: ${theme.colors.r500};
    color: ${theme.colors.y500};
    font-size: ${theme.typography.text.giga.fontSize};
    padding: ${theme.spacings.bit} ${theme.spacings.byte} ${theme.spacings.bit} ${theme.spacings.giga};
  `

export const Discount = styled.span(discountStyle)

const warningNotificationStyle = ({ theme }) =>
  css`
    label: price-tag__warning;

    background-color: ${theme.colors.y100};
    border: 1px solid ${theme.colors.y500};
    border-radius: ${theme.borderRadius.mega};
    color: ${theme.colors.n800};
    padding: ${theme.spacings.kilo};
  `

export const WarningNotification = styled.div(warningNotificationStyle)

const packagingPriceStyles = ({ theme }) => css`
  label: price-tag__packaging-price;

  width: 100%;
  background: ${theme.colors.p200};
  margin: ${theme.spacings.bit} 0;
  padding: ${theme.spacings.byte} ${theme.spacings.kilo};
`

export const PackagingPrice = styled('div')(packagingPriceStyles)

const dotStyles = ({ theme }) => css`
  label: price-tag__packaging-price-dot;

  &::after {
    content: '';

    display: inline-block;

    width: ${theme.spacings.bit};
    height: ${theme.spacings.bit};

    background-color: ${theme.colors.n900};

    vertical-align: middle;

    border-radius: ${theme.borderRadius.circle};
  }
`

export const Dot = styled('span')(dotStyles)
